import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpProgressEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../shared/interfaces/user.interface';
import { Pagination } from '../shared/interfaces/pagination.interface';

@Injectable({
  providedIn: 'root',
})
export class MembersService {
  constructor(private http: HttpClient) {}

  get(query?: any): Promise<any> {
    let params = new HttpParams({ fromObject: query });

    return this.http.get(`@cec-api/user`, { params }).toPromise();
  }

  getByCECID(cecID: any) {
    const params = new HttpParams({ fromObject: { CECID: cecID } });
    return this.http.get(`@cec-api/user/`, { params }).toPromise();
  }

  getByGroup(groupId: number): Promise<any> {
    return this.http.get(`@cec-api/groups/${groupId}/users`).toPromise();
  }

  getById(id: string): Promise<any> {
    return this.http.get('@cec-api/user/' + id).toPromise();
  }

  addUser(user: User): Promise<any> {
    return this.http.post('@cec-api/user', user).toPromise();
  }

  updateUser(user: User, id: string): Promise<any> {
    return this.http.put('@cec-api/user/' + id, user).toPromise();
  }

  deleteUser(id: string): Promise<any> {
    return this.http.delete('@cec-api/user/' + id).toPromise();
  }

  searchMember(searchValue: string): Promise<any> {
    return this.http.get('@cec-api/user-search?name=' + searchValue).toPromise();
  }

  getFather(name: string, gender: string) {
    return this.http.get(`@cec-api/fathers?name=${name}&gender=${gender}`).toPromise();
  }

  changeAvatar(memberId: number, form: FormData): Observable<HttpEvent<Object>> {
    return this.http.post('@cec-api/user/avatar/' + memberId, form, {
      reportProgress: true,
      observe: 'events',
      headers: { encrypt: 'multipart/form-data' },
    });
  }

  getBirthdays() {
    return this.http.get('@cec-api/user/birthdays').toPromise();
  }
}
